import React from 'react'
import HeadingArea from '../../general/HeadingArea';
import { useState, useEffect } from 'react';
import ResponseMsg2 from '../../general/ResponseMsg2';
import axios from 'axios'
import { MdOutlineEdit } from 'react-icons/md';
import { RiDeleteBin6Line } from 'react-icons/ri';
import { AiOutlineEdit, AiOutlinePlus } from 'react-icons/ai';

const Grievances = ({ setLoading, userData }) => {
    const [detail, setDetail] = useState([]);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editGrievanceId, setEditGrievanceId] = useState(null);
    const [showDelete, setShowDelete] = useState(false);
    const [selectedGrievance, setSelectedGrievance] = useState({});
    const [searchTerm, setSearchTerm] = useState('');
    const [employee, setEmployee] = useState([]);
    const [selectedStaff, setSelectedStaff] = useState('');

    const [selectedAY, setSelectedAY] = useState('');


    const [formData, setFormData] = useState({
        grievance_date: '',
        title: '',
        suggestion: '',
        issue_type: '',
        staff: '',
        ay: '',
        class_name: '',
        section: '',
        emp_role: '',
        student_id: '',
    });

    const [classes, setClasses] = useState([]);
    const [availableSections, setAvailableSections] = useState([]);
    const [selectedClassId, setSelectedClassId] = useState('');
    const [selectedSection, setSelectedSection] = useState('');
    const [ay, setAy] = useState([]);
    const [response2, setResponse2] = useState({ message: '', status: 'success' });
    const [issueType, setIssueType] = useState([]);
    const [student, setStudent] = useState([]);



    const handleAddNewIssue = () => {
        const newIssue = prompt('Enter new issue type:');
        if (newIssue && !issueType.includes(newIssue)) {
            setIssueType((prev) => [...prev, newIssue]);
            setFormData((prev) => ({
                ...prev,
                issue_type: newIssue
            }));
        }
    };



    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === 'class_name') {
            const selectedClass = classes.find((cls) => cls.id.toString() === value);

            setFormData((prev) => ({
                ...prev,
                class_name: selectedClass
                    ? { classId: selectedClass.id, className: selectedClass.class_name }
                    : '',
            }));
        }

        else if (name === 'staff') {
            setSelectedStaff(value);
            setFormData((prev) => ({
                ...prev,
                staff: value,
                emp_role: ''
            }));
        }

        else {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };



    const fetchClasses = async () => {
        setLoading(true);
        try {
            const response = await fetch('https://api.kcian.in/get-classes');

            if (response.ok) {
                const data = await response.json();
                setClasses(data);
                setLoading(false);


            } else {
                setLoading(false);
                console.error('Failed to fetch class');
            }
        } catch (error) {
            setLoading(false);
            console.error('Error fetching data:', error);
        }
    }


    const fetchAcademicYears = async () => {
        setLoading(true);
        try {
            const response = await fetch('https://api.kcian.in/get-academic-years');

            if (response.ok) {
                const data = await response.json();
                setAy(data);
            } else {
                console.error('Failed to fetch academic years');
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        if (selectedClassId) {
            const selectedClass = classes.find((cls) => cls.id === Number(selectedClassId));
            if (selectedClass && selectedClass.sections) {
                const sectionArray = selectedClass.sections
                    .split(',')
                    .map((s) => s.trim())
                    .filter((s) => s !== '');
                setAvailableSections(sectionArray);
            } else {
                setAvailableSections([]);
            }
            setSelectedSection('');
        } else {
            setAvailableSections([]);
            setSelectedSection('');
        }
    }, [selectedClassId, classes]);


    useEffect(() => {
        fetchClasses();
        fetchAcademicYears();
        fetchGriev();
        fetchIssue();
        fetchEmployee();
    }, [])


useEffect(() => {
    if (isEditMode && selectedClassId && selectedAY) {
        handleSearch();
    }
}, [isEditMode, selectedClassId, selectedAY]);



    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);

        try {
            const response = editGrievanceId ? await axios.put(`https://api.kcian.in/update-grievance/${editGrievanceId}`,
                {
                    grievance_date: formData.grievance_date,
                    title: formData.title,
                    suggestion: formData.suggestion,
                    issue_type: formData.issue_type,
                    staff: formData.staff,
                    added_by: userData.user_id,
                    ay: selectedAY || '',
                    class_name: formData.class_name ? formData.class_name : '',
                    section: selectedSection || '',
                    student_id: formData.student_id,
                    emp_role: formData.emp_role
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            ) : await axios.post(
                'https://api.kcian.in/add-grievance',
                {
                    grievance_date: formData.grievance_date,
                    title: formData.title,
                    suggestion: formData.suggestion,
                    issue_type: formData.issue_type,
                    staff: formData.staff,
                    ay: formData.ay,
                    class_name: formData.class_name,
                    section: formData.section,
                    added_by: userData.user_id,
                    ay: selectedAY || '',
                    class_name: formData.class_name ? formData.class_name : '',
                    section: selectedSection || '',
                    student_id: formData.student_id,
                    emp_role: formData.emp_role
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );

            setResponse2({
                message: editGrievanceId ? 'Grievance updated!' : 'Grievance added!',
                status: 'success'
            });
                        fetchGriev();
            setFormData({

                grievance_date: '',
                title: '',
                suggestion: '',
                issue_type: '',
                staff: '',
                ay: '',
                class_name: '',
                section: '',
                student_id: '',
                emp_role: '',
            });

            setSelectedAY('');
            setSelectedClassId('');
            setSelectedSection('');

            setTimeout(() => {
                setResponse2('');
            }, 2000);
            setIsEditMode(false);
            setEditGrievanceId(null);
            setLoading(false);
        } catch (error) {
            console.error('Error submitting form:', error);
            setLoading(false);
        }
    };


    const fetchGriev = async () => {
        setLoading(true)
        try {
            const res = await axios.get('https://api.kcian.in/fetch-grievance');
            setDetail(res.data);
            setLoading(false);
        } catch (error) {
            console.log(error)
            setLoading(false)
        }
    };

    const fetchIssue = async () => {
        try {
            const res = await axios.get('https://api.kcian.in/fetch-issue-types');
            setIssueType(res.data);
            setLoading(false);
        } catch (error) {
            console.log(error)
            setLoading(false);
        }
    };

    const handleShowDelete = (data) => {
        setSelectedGrievance(data);
        setShowDelete(true);
    }


const handleEdit = async (data) => {
    const parsedClass = data.class_id ? JSON.parse(data.class_id) : '';

    const classId = parsedClass?.classId?.toString() || '';
    const section = data.section || '';
    const ay = data.ay || '';

    setSelectedClassId(classId);
    setSelectedSection(section);
    setSelectedAY(ay);

    // Set form data
    setFormData({
        grievance_date: data.grievance_date,
        title: data.title,
        suggestion: data.suggestion,
        issue_type: data.issue_type,
        staff: data.staff,
        ay: ay,
        class_name: parsedClass,
        section: selectedSection,
        student_id: data.student_id,
        emp_role: data.emp_id,
    });

    setIsEditMode(true);
    setEditGrievanceId(data.id);
};



    const handleDelete = async (greivanceId) => {
        setLoading(true);
        try {
            const response = await axios.delete(`https://api.kcian.in/delete-grievance/${greivanceId}`);

            setResponse2({ message: 'Grievance Removed Successfully!', status: 'success' });
            setShowDelete(false);
            fetchGriev();
            setTimeout(() => {
                setResponse2('');
            }, 3000);
            setLoading(false)
        } catch (error) {
            console.error('Error deleting:', error);
            setLoading(false);
        }
    };


    const filterGrievance = detail.filter(tt => {
        const term = searchTerm.toLowerCase();
        return (
            tt.title.toLowerCase().includes(term) ||
            tt.issue_type.toLowerCase().includes(term) ||
            tt.staff.toLowerCase().includes(term) ||
            tt.teacher_name.toLowerCase().includes(term) ||
            tt.student_name.toLowerCase().includes(term)
        );
    });

    const fetchEmployee = async () => {
        setLoading(true)
        try {
            const res = await axios.get('https://api.kcian.in/get-employee');
            setEmployee(res.data);
            const filteredEmployees = employee.filter(emp => emp.designation === selectedStaff);
            setLoading(false);
        } catch (error) {
            console.log(error)
            setLoading(false)
        }
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");

        return `${day}-${month}-${year} `;
    };

    const filteredEmployees = Array.isArray(employee)
        ? employee.filter(emp =>
            emp.designation?.toLowerCase().includes(selectedStaff?.toLowerCase())
        )
        : [];

    const handleSearch = async (e) => {

        setLoading(true);
        // setLoading(true);
        const selectedClass = classes.find((cls) => cls.id === Number(selectedClassId));
        const className = selectedClass ? selectedClass.class_name : '';

        // Build query params
        const params = new URLSearchParams();
        params.append('ay', selectedAY);
        params.append('class_name', className);

        if (selectedSection) {
            params.append('section', selectedSection);
        }

        const url = `https://api.kcian.in/get-student?${params.toString()}`;

        const response = await fetch(url);
        const data = await response.json();
       
        setStudent(data);
        setLoading(false);

    }


    return (
                <>
            <section className='py-4'>
        <div className="px-4">
            <HeadingArea message1="Utilities" message2="Grievances" />

                    {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}
            <div className='row'>
                <div className='col-xl-3 col-lg-4 col-md-5 col-12 my-2'>

                    <div className="profile-card">
                        <p className="profile-heading">{isEditMode ? 'Update' : 'Add' } Complaint</p>
                        <form className='mt-4' onSubmit={handleSubmit} >



                            <div className='profile-input-area mb-4'>
                                <label className='profile-badge'>Add Issue Type*</label>
                                <select name='issue_type' value={formData.issue_type} onChange={(e) => {
                                    if (e.target.value === 'add_new') {
                                        handleAddNewIssue();
                                    } else {
                                        handleChange(e);
                                    }
                                }} className='profile-input' required>
                                    <option value=''>--- Select ---</option>
                                    {issueType.map((i_type, index) => (
                                        <option key={index} value={i_type}>{i_type}</option>
                                    ))}
                                    <option value='add_new'>+ Add New Issue Type</option>

                                </select>
                            </div>




                            <div className='profile-input-area mb-4 '>
                                <label className='profile-badge'>Employee Role*</label>
                                <select name='staff' value={formData.staff} onChange={handleChange} className='profile-input' required>
                                    <option value=''>Select Staff</option>
                                    <option value='Teacher'>Teacher</option>
                                    <option value="Librarian">Librarian</option>
                                    <option value="Hostel">Hostel</option>
                                    <option value="Transport">Transport</option>
                                </select>
                            </div>


                            <div className='profile-input-area mb-4'>
                                <label className="profile-badge">Staff*</label>
                                <select
                                    className="profile-input"
                                    name='emp_role'
                                    value={formData.emp_role}
                                    onChange={handleChange}
                                    required
                                    disabled={!selectedStaff}
                                >
                                    <option value="">-- Select Employee --</option>
                                    {filteredEmployees.map((emp) => (
                                        <option key={emp.id} value={emp.id}>
                                            {emp.name}
                                        </option>
                                    ))}
                                </select>
                            </div>



                            <div className='profile-input-area mb-4'>
                                <label className="profile-badge">Select AY*</label>
                                <select
                                    className="profile-input"
                                    name='ay'
                                    value={selectedAY}
                                    onChange={(e) => setSelectedAY(e.target.value)}
                                    required
                                >
                                    <option value="">-- Select Academic Year --</option>
                                    {ay.map((ayear) => (
                                        <option key={ayear.year} value={ayear.year}>
                                            {ayear.year} --- {ayear.title}
                                        </option>
                                    ))}
                                </select>
                            </div>


                            <div className='profile-input-area mb-4'>
                                <label className="profile-badge">Select Class*</label>

                                <select
                                    className="profile-input"
                                    name='class_name'
                                    value={selectedClassId}
                                    onChange={(e) => {
                                        const selectedId = e.target.value;
                                        setSelectedClassId(selectedId);

                                        const selectedClass = classes.find(cls => cls.id.toString() === selectedId);

                                        setFormData(prev => ({
                                            ...prev,
                                            class_name: selectedClass
                                                ? { classId: selectedClass.id, className: selectedClass.class_name }
                                                : ''
                                        }));
                                    }}
                                    required
                                >
                                    <option value="">-- Select Class --</option>
                                    {classes.map((cls) => (
                                        <option key={cls.id} value={cls.id}>
                                            {cls.class_name}
                                        </option>
                                    ))}
                                </select>

                            </div>


                            <div className='profile-input-area mb-4'>
                                <label className="profile-badge">Select Section*</label>
                                <select
                                    className="profile-input"

                                    value={selectedSection}

                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setSelectedSection(value);
                                        handleSearch(value);
                                    }}

                                    required
                                    disabled={availableSections.length === 0}
                                >
                                    <option value="">-- Select Section --</option>
                                    {availableSections.map((section, idx) => (
                                        <option key={idx} value={section}>
                                            {section}
                                        </option>
                                    ))}
                                </select>

                            </div>

                            <div className='profile-input-area mb-4'>
                                <label className="profile-badge">Select Student*</label>
                                <select
                                    className="profile-input"
                                    name='student_id'
                                    value={formData.student_id}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">-- Select Student --</option>

                                    {student.map((std) => (
                                        <option key={std.id} value={std.id}>
                                            {std.name}
                                        </option>
                                    ))}

                                </select>

                            </div>

                            <div className="profile-input-area mb-4">
                                <label htmlFor="homework" className="profile-badge">
                                    Date*
                                </label>
                                <input
                                    type="date"
                                    id="homework"
                                    className="profile-input"
                                    name='grievance_date'
                                    value={formData.grievance_date}
                                    onChange={handleChange}
                                    required
                                />
                            </div>



                            <div className='profile-input-area mb-4'>
                                <label className='profile-badge'>Title*</label>
                                <input type='text' className='profile-input' placeholder='Add...'
                                    name='title'
                                    value={formData.title}
                                    onChange={handleChange}
                                    required
                                />
                            </div>


                            <div className="profile-input-area mb-4">
                                <label htmlFor="homework" className="profile-badge mt-2">
                                    Suggestion
                                </label>
                                <textarea name="suggestion" value={formData.suggestion} onChange={handleChange} className="profile-input" />
                            </div>






                            <div className='text-center mt-4'>
                                <button type="submit" className="profile-btn me-2">
                                    {isEditMode ? (
                                        <>
                                            <AiOutlineEdit /> Update
                                        </>
                                    ) : (
                                        <>
                                            <AiOutlinePlus /> Add
                                        </>
                                    )}
                                </button>
                                {isEditMode && (
                                    <button
                                        type="button"
                                        className="profile-btn2"
                                        onClick={() => {
                                            setFormData({

                                                grievance_date: '',
                                                title: '',
                                                suggestion: '',
                                                issue_type: '',
                                                staff: '',
                                                ay: '',
                                                class_name: '',
                                                section: '',
                                                student_id: '',
                                                emp_role: '',
                                            });

                                            setSelectedAY('');
                                            setSelectedClassId('');
                                            setSelectedSection('');

                                            setIsEditMode(false);
                                            setEditGrievanceId(null);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                )}
                            </div>

                        </form>
                    </div>
                </div>

                {/* Right side */}

                <div className='col-xl-9 col-lg-8 col-md-7 col-12 my-2 h-100'>
                    <div className='profile-card'>

                        <div className='d-md-flex d-sm-flex justify-content-between mb-2'>
                            <span className="profile-heading align-content-center">Grievance List</span>

                            <div className='profile-input-area ms-auto col-lg-3 border-0'>
                                <input
                                    type='text'
                                    name='search'
                                    className='profile-input border-bottom rounded-0'
                                    placeholder='Search..'
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className='table-responsive'>
                            <table className='w-100 text-center '>

                                <thead className='account-thead'>
                                    <tr>
                                        <th className='rounded-start-4'>SL</th>
                                        <th>Complaint By</th>
                                        <th>Issue Title/ Type</th>
                                        <th>Related Staff</th>
                                        <th>Related Student</th>
                                        <th>Date</th>
                                        <th className='rounded-end-4'>Actions</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {filterGrievance.length > 0 ? (
                                        filterGrievance.map((data, id) => (
                                            <tr key={id} className='account-tr'>
                                                <td>{id + 1}</td>
                                                <td> {data.addedby_name} ({data.designation}) </td>
                                                <td>{data.title}<br />({data.issue_type} Issue) </td>
                                                <td>{data.teacher_name}<br />({data.teacher_designation})</td>
<td>
  {data.student_name}<br />
  {(() => {
    try {
      const parsedClass = JSON.parse(data.class_id);
      return parsedClass.className || '--';
    } catch (e) {
      return '--';
    }
  })()} {data.section}
</td>
                                                <td>{formatDate(data.grievance_date)}</td>

                                                <td><MdOutlineEdit className='account-icon1' title='Edit' onClick={() => handleEdit(data)} /> &nbsp;&nbsp;<RiDeleteBin6Line className='account-icon2' title='Remove' onClick={() => handleShowDelete(data)} /></td>

                                            </tr>
                                        ))) :
                                        <tr className='account-tr'>
                                            <td colSpan="6">
                                                No Data found.
                                            </td>
                                        </tr>
                                    }
                                </tbody>


                            </table>
                        </div>

                    </div>
                </div>
                {showDelete && (
                    <>
                        <section className='ins-dialog'>
                            <div className='ins-dialog-inner col-lg-10 col-12 animate__animated animate__fadeInDown mx-auto' onClick={(e) => e.stopPropagation()}>

                                <p className='ins-dialog-heading text-danger'>Remove This Grievance!</p>

                                <div className='table-responsive'>
                                    <table className='w-100'>

                                        <thead className='account-thead'>
                                        <th className='rounded-start-4'>Complaint By</th>
                                        <th>Issue Title/ Type</th>
                                        <th>Suggestion</th>
                                        <th>Related Staff</th>
                                        <th>Related Student</th>
                                        <th className='rounded-end-4'>Date</th>
                                                                                </thead>

                                        <tr className='account-tr'>
                                                <td> {selectedGrievance.addedby_name} ({selectedGrievance.designation}) </td>
                                                <td>{selectedGrievance.title}<br />({selectedGrievance.issue_type} Issue) </td>
                                                <td>{selectedGrievance.suggestion || '--'}</td>
                                                <td>{selectedGrievance.teacher_name}<br />({selectedGrievance.teacher_designation})</td>
<td>
  {selectedGrievance.student_name}<br />
  {(() => {
    try {
      const parsedClass = JSON.parse(selectedGrievance.class_id);
      return parsedClass.className || '--';
    } catch (e) {
      return '--';
    }
  })()} {selectedGrievance.section}
</td>
                                                <td>{formatDate(selectedGrievance.grievance_date)}</td>
                                        </tr>

                                    </table>
                                </div>

                                <p className='para-text mt-3'>Note: This action cannot be undone. Once deleted, the Grievance will be permanently removed.</p>

                                <button className='profile-btn me-2' onClick={() => handleDelete(selectedGrievance.id)}>Remove</button>
                                <button className='profile-btn2' onClick={() => setShowDelete(false)}>Go Back</button>


                            </div>
                        </section>
                    </>
                )}

            </div>
        </div>

</section>
        </>
    )
}

export default Grievances